import { useEffect } from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { browserLogger } from '../../utils/loggers/browser';
export type ExecuteReCaptcha = (action?: string) => Promise<string>;
interface ReCaptchaV3ControllerProps {
  enabled: boolean;
  siteKey?: string;
  onExecuteReCaptchaChange: (executeReCaptcha: ExecuteReCaptcha | undefined) => void;
}
const ReCaptchaV3ExecutionBridge = ({
  onExecuteReCaptchaChange
}: Pick<ReCaptchaV3ControllerProps, 'onExecuteReCaptchaChange'>) => {
  const {
    executeRecaptcha: executeReCaptcha
  } = useGoogleReCaptcha();
  useEffect(() => {
    onExecuteReCaptchaChange(executeReCaptcha);
    return () => onExecuteReCaptchaChange(undefined);
  }, [executeReCaptcha, onExecuteReCaptchaChange]);
  return null;
};
export const ReCaptchaV3Controller = ({
  enabled,
  siteKey,
  onExecuteReCaptchaChange
}: ReCaptchaV3ControllerProps) => {
  useEffect(() => {
    if (enabled && !siteKey) {
      browserLogger({
        level: 'error',
        team: 'client-onboarding',
        feature: 'email-login',
        message: 'reCAPTCHA v3 enabled without a site key'
      });
    }
  }, [enabled, siteKey]);

  // A missing key is a config error (logged above); don't mount without one.
  if (!enabled || !siteKey) return null;
  return <GoogleReCaptchaProvider reCaptchaKey={siteKey} useEnterprise>
      <ReCaptchaV3ExecutionBridge onExecuteReCaptchaChange={onExecuteReCaptchaChange} />
    </GoogleReCaptchaProvider>;
};